import { useEffect, useState } from 'react';
import { useDebounce } from './useDebounce';

/** Хук для получения размеров экрана с необходимой задержкой
 * @param debounce - задержка обновления значений в мс, default = 0
 * @returns - ширину и высоту экрана
 *
 * @example
 *
 * const { width, height } = useWindowSize(100)
 */
export const useWindowSize = (debounce = 0) => {
  const [windowSize, setWindowSize] = useState<{ width?: number; height?: number }>({
    width: undefined,
    height: undefined,
  });

  const handleResize = useDebounce(() => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, debounce);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);

      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return windowSize;
};
